/**
 * 방송 기능 — 호스트/뷰어 모드 + Cloudflare DO WebSocket.
 *
 * 현재 Phase 1: 상태·Start 동기화. (각자 시뮬 실행)
 * Phase 2 예정: 프레임 스트리밍(완전 동일 재생).
 */ (function() {
    const SERVER_URL = 'https://marble-roulette-server.verykind1004.workers.dev';
    const WS_URL = SERVER_URL.replace(/^https?/, 'wss');
    const MODE = {
        SOLO: 'solo',
        HOST: 'host',
        VIEWER: 'viewer'
    };
    let mode = MODE.SOLO;
    let ws = null;
    let roomId = null;
    let reconnectTimer = null;
    let bindingsSet = false;
    let viewerCount = 0;
    let lastSentState = '';
    let frameTimer = null;
    const FRAME_HZ = 30;
    let framesReceived = 0;
    let lastFrameAt = 0;
    const $ = (sel)=>document.querySelector(sel);
    // ─── 초기화 ───
    function init() {
        wireButtons();
        // URL에 ?room=CODE 있으면 자동으로 뷰어 모드로 참가
        const params = new URLSearchParams(location.search);
        const urlRoom = (params.get('room') || '').toUpperCase();
        if (urlRoom && /^[A-Z0-9]{4,8}$/.test(urlRoom)) setTimeout(()=>joinRoom(urlRoom), 500);
        updateUI();
    }
    function wireButtons() {
        $('#btnCreateRoom')?.addEventListener('click', createRoom);
        $('#btnJoinRoom')?.addEventListener('click', ()=>{
            const code = ($('#roomCodeInput').value || '').trim().toUpperCase();
            if (!code) return;
            joinRoom(code);
        });
        $('#roomCodeInput')?.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') $('#btnJoinRoom').click();
        });
        $('#btnLeaveRoom')?.addEventListener('click', leaveRoom);
        $('#btnCopyRoom')?.addEventListener('click', copyRoomLink);
        $('#btnShareRoom')?.addEventListener('click', shareRoomLink);
    }
    // ─── 방 만들기 (호스트) ───
    async function createRoom() {
        if (mode !== MODE.SOLO) return;
        try {
            const res = await fetch(SERVER_URL + '/rooms', {
                method: 'POST'
            });
            if (!res.ok) throw new Error("\uBC29 \uC0DD\uC131 \uC2E4\uD328");
            const { roomId: id } = await res.json();
            roomId = id;
            connectAs(MODE.HOST);
        } catch (e) {
            alert("\uBC29 \uB9CC\uB4E4\uAE30 \uC2E4\uD328: " + e.message);
        }
    }
    // ─── 방 참가 (뷰어) ───
    function joinRoom(code) {
        if (mode !== MODE.SOLO) return;
        roomId = code;
        connectAs(MODE.VIEWER);
    }
    function leaveRoom() {
        if (ws) try {
            ws.close();
        } catch  {}
        ws = null;
        roomId = null;
        mode = MODE.SOLO;
        viewerCount = 0;
        if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = null;
        }
        stopFrameLoop();
        updateUI();
        toast("\uBC29\uC5D0\uC11C \uB098\uC654\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C\uACE0\uCE68 \uD6C4 \uC194\uB85C \uBAA8\uB4DC \uC0AC\uC6A9 \uAD8C\uC7A5.");
    }
    // 뷰어: physics를 원격 주입용으로 교체 (roulette.isReady 대기)
    function enterViewerModePhysics() {
        const api = window.MarbleBroadcast;
        if (!api) {
            console.warn("MarbleBroadcast \uD6C5 \uC5C6\uC74C \u2014 \uC7AC\uC2DC\uB3C4");
            setTimeout(enterViewerModePhysics, 200);
            return;
        }
        if (!window.roulette || !window.roulette.isReady) {
            setTimeout(enterViewerModePhysics, 200);
            return;
        }
        api.enterViewerMode();
        console.log('[broadcast] viewer mode engaged');
    }
    // ─── WebSocket 연결 ───
    function connectAs(role) {
        const url = `${WS_URL}/rooms/${roomId}/${role === MODE.HOST ? 'host' : 'viewer'}`;
        try {
            ws = new WebSocket(url);
        } catch (e) {
            toast("\uC5F0\uACB0 \uC2E4\uD328: " + e.message);
            return;
        }
        ws.addEventListener('open', ()=>{
            mode = role;
            updateUI();
            toast(role === MODE.HOST ? `\u{BC29} \u{B9CC}\u{B4E4}\u{C5B4}\u{C9D0}: ${roomId}` : `\u{C785}\u{C7A5} \u{C644}\u{B8CC}: ${roomId}`);
            if (role === MODE.HOST) {
                lastSentState = '';
                setupHostBindings();
                sendCurrentState();
            } else {
                setupViewerBindings();
                enterViewerModePhysics();
            }
        });
        ws.addEventListener('message', (e)=>{
            try {
                const msg = JSON.parse(e.data);
                onServerMessage(msg);
            } catch  {}
        });
        ws.addEventListener('close', (e)=>{
            if (mode !== MODE.SOLO) {
                toast("\uC5F0\uACB0\uC774 \uB04A\uACBC\uC2B5\uB2C8\uB2E4. (5\uCD08 \uB4A4 \uC7AC\uC2DC\uB3C4)");
                scheduleReconnect();
            }
        });
        ws.addEventListener('error', ()=>{
        // 브라우저는 자세한 에러 안 줌 → close에서 재시도
        });
    }
    function scheduleReconnect() {
        if (reconnectTimer || mode === MODE.SOLO || !roomId) return;
        reconnectTimer = setTimeout(()=>{
            reconnectTimer = null;
            if (mode !== MODE.SOLO && roomId) connectAs(mode);
        }, 5000);
    }
    // ─── 서버 메시지 처리 ───
    function onServerMessage(msg) {
        switch(msg.type){
            case 'viewer_count':
                viewerCount = msg.count || 0;
                updateViewerCount();
                break;
            case 'host_disconnected':
                toast("\uD638\uC2A4\uD2B8 \uC5F0\uACB0\uC774 \uB04A\uACBC\uC2B5\uB2C8\uB2E4.");
                break;
            case 'state':
                if (mode === MODE.VIEWER) applyStateFromHost(msg.data);
                break;
            case 'start':
                if (mode === MODE.VIEWER) applyStartFromHost(msg.data);
                break;
            case 'frame':
                if (mode === MODE.VIEWER && msg.data && window.MarbleBroadcast) {
                    window.MarbleBroadcast.applyFrame(msg.data);
                    framesReceived++;
                    lastFrameAt = Date.now();
                    updateDiagnostic();
                }
                break;
            case 'goal':
                // 뷰어는 freezePhysics 라 로컬 goal 이벤트 안 나오므로 직접 dispatch
                if (mode === MODE.VIEWER && window.roulette) try {
                    window.roulette.dispatchEvent(new CustomEvent('goal', {
                        detail: {
                            winner: msg.data?.winner || null
                        }
                    }));
                } catch  {}
                break;
        }
    }
    function updateDiagnostic() {
        const el = document.getElementById('viewerDiagnostic');
        if (!el) return;
        const freshness = lastFrameAt ? ((Date.now() - lastFrameAt) / 1000).toFixed(1) + "s \uC804" : "\uC218\uC2E0 \uC5C6\uC74C";
        el.textContent = `frames: ${framesReceived} / \u{B9C8}\u{C9C0}\u{B9C9}: ${freshness}`;
    }
    // ─── 호스트: 송출 ───
    function setupHostBindings() {
        if (bindingsSet) return;
        bindingsSet = true;
        // 참가자·맵 변경 감지 (textarea input, map select change, winning rank change)
        const names = $('#in_names');
        const map = $('#sltMap');
        const rank = $('#in_winningRank');
        names?.addEventListener('input', debounceSendState);
        map?.addEventListener('change', sendCurrentState);
        rank?.addEventListener('change', sendCurrentState);
        // Start 버튼 가로채기 — 뷰어에게 신호 보내고 프레임 스트리밍 시작
        const startBtn = $('#btnStart');
        if (startBtn) startBtn.addEventListener('click', ()=>{
            if (mode === MODE.HOST) {
                sendMessage('start', {
                    startAt: Date.now() + 300
                });
                startFrameLoop();
            }
        });
        // 호스트 측 goal 이벤트 수신 → 뷰어에게 알림 + 프레임 루프 종료
        if (window.roulette && typeof window.roulette.addEventListener === 'function') window.roulette.addEventListener('goal', (e)=>{
            if (mode === MODE.HOST) {
                sendMessage('goal', {
                    winner: e?.detail?.winner || null
                });
                stopFrameLoop();
            }
        });
    }
    // ─── 호스트 프레임 송출 (20Hz) ───
    function startFrameLoop() {
        stopFrameLoop();
        if (!window.MarbleBroadcast) return;
        const interval = Math.round(1000 / FRAME_HZ);
        frameTimer = setInterval(()=>{
            if (mode !== MODE.HOST || !ws || ws.readyState !== 1) {
                stopFrameLoop();
                return;
            }
            const frame = window.MarbleBroadcast.extractFrame();
            if (frame && frame.length) sendMessage('frame', frame);
        }, interval);
    }
    function stopFrameLoop() {
        if (frameTimer) {
            clearInterval(frameTimer);
            frameTimer = null;
        }
    }
    let sendStateTimer = null;
    function debounceSendState() {
        if (sendStateTimer) clearTimeout(sendStateTimer);
        sendStateTimer = setTimeout(sendCurrentState, 300);
    }
    function sendCurrentState() {
        if (mode !== MODE.HOST || !ws || ws.readyState !== 1) return;
        const names = ($('#in_names')?.value || '').trim();
        const mapIndex = $('#sltMap')?.value ?? '0';
        const winningRank = parseInt($('#in_winningRank')?.value || '1', 10);
        const state = {
            names,
            mapIndex,
            winningRank
        };
        const serialized = JSON.stringify(state);
        if (serialized === lastSentState) return;
        lastSentState = serialized;
        sendMessage('state', state);
    }
    function sendMessage(type, data) {
        if (!ws || ws.readyState !== 1) return;
        ws.send(JSON.stringify({
            type,
            data
        }));
    }
    // ─── 뷰어: 수신 적용 ───
    function setupViewerBindings() {
        // 편집 UI 비활성화
        setReadOnly(true);
    }
    function applyStateFromHost(state) {
        if (!state) return;
        // 이름 목록 반영
        const ta = $('#in_names');
        if (ta && typeof state.names === 'string' && ta.value !== state.names) {
            ta.value = state.names;
            ta.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        }
        // 맵
        const map = $('#sltMap');
        if (map && state.mapIndex !== undefined && map.value !== String(state.mapIndex)) {
            map.value = String(state.mapIndex);
            map.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
        // 목표 순위
        const rank = $('#in_winningRank');
        if (rank && state.winningRank !== undefined && parseInt(rank.value, 10) !== state.winningRank) {
            rank.value = String(state.winningRank);
            rank.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    }
    function applyStartFromHost(data) {
        if (!window.roulette) return;
        // 호스트와 동시 시작 — 약간의 네트워크 지연 보정을 위해 startAt 까지 기다림
        const startAt = data && data.startAt || Date.now();
        const delay = Math.max(0, startAt - Date.now());
        setTimeout(()=>{
            try {
                window.roulette.start();
                // 원본 UI도 닫기
                document.querySelector('#settings')?.classList.add('hide');
            } catch (e) {
                console.warn("start \uC2E4\uD328", e);
            }
        }, delay);
    }
    function setReadOnly(flag) {
        const block = document.querySelector('.settings');
        if (!block) return;
        block.classList.toggle('viewer-mode', flag);
        // 주요 편집 요소 비활성화
        [
            '#in_names',
            '#newParticipantName',
            '#btnAddParticipant',
            '#btnClearAll',
            '#btnTemplates',
            '#btnRecent',
            '#btnAdvancedMode',
            '#sltMap',
            '#in_winningRank',
            '#chkSkill',
            '#btnShuffle',
            '#btnStart',
            '.btn-first-winner',
            '.btn-last-winner'
        ].forEach((sel)=>{
            document.querySelectorAll(sel).forEach((el)=>{
                el.setAttribute('disabled', '');
                el.classList.add('vm-disabled');
            });
        });
        // 카드 내부 스텝퍼/삭제도
        document.querySelectorAll('.participants-list input, .participants-list button').forEach((el)=>{
            el.setAttribute('disabled', '');
        });
    }
    function unsetReadOnly() {
        const block = document.querySelector('.settings');
        if (!block) return;
        block.classList.remove('viewer-mode');
        document.querySelectorAll('.vm-disabled').forEach((el)=>{
            el.removeAttribute('disabled');
            el.classList.remove('vm-disabled');
        });
        document.querySelectorAll('.participants-list input, .participants-list button').forEach((el)=>{
            el.removeAttribute('disabled');
        });
    }
    // ─── UI 업데이트 ───
    function updateUI() {
        const actionsEl = $('#broadcastActions');
        const roomEl = $('#broadcastRoom');
        const statusEl = $('#broadcastStatus');
        if (mode === MODE.SOLO) {
            if (actionsEl) actionsEl.classList.remove('hidden');
            if (roomEl) roomEl.classList.add('hidden');
            if (statusEl) statusEl.textContent = "\uC194\uB85C \uBAA8\uB4DC";
            unsetReadOnly();
        } else {
            if (actionsEl) actionsEl.classList.add('hidden');
            if (roomEl) roomEl.classList.remove('hidden');
            if (statusEl) statusEl.textContent = mode === MODE.HOST ? "\uD83D\uDD34 \uD638\uC2A4\uD2B8 (\uBC29\uC1A1 \uC911)" : "\uD83D\uDCFA \uBDF0\uC5B4 (\uC2DC\uCCAD \uC911)";
            const codeEl = $('#currentRoomCode');
            if (codeEl) codeEl.textContent = roomId || '';
            const roleRow = $('#hostOnlyRow');
            if (roleRow) roleRow.classList.toggle('hidden', mode !== MODE.HOST);
        }
        updateViewerCount();
    }
    function updateViewerCount() {
        const el = $('#viewerCountDisplay');
        if (!el) return;
        if (mode === MODE.HOST) {
            el.textContent = `\u{1F441} ${viewerCount}\u{BA85} \u{C2DC}\u{CCAD} \u{C911}`;
            el.style.display = '';
        } else if (mode === MODE.VIEWER) {
            el.textContent = "\uD83D\uDCFA \uC2DC\uCCAD \uC911";
            el.style.display = '';
        } else el.style.display = 'none';
    }
    // ─── 링크 공유 ───
    function buildRoomLink() {
        const url = new URL(location.href);
        url.search = '';
        url.searchParams.set('room', roomId);
        return url.toString();
    }
    async function copyRoomLink() {
        const link = buildRoomLink();
        try {
            await navigator.clipboard.writeText(link);
            toast("\uB9C1\uD06C \uBCF5\uC0AC\uB428");
        } catch  {
            prompt("\uB9C1\uD06C \uBCF5\uC0AC", link);
        }
    }
    async function shareRoomLink() {
        const link = buildRoomLink();
        const title = "\uB9C8\uBE14 \uB8F0\uB81B \uBC29\uC1A1";
        const text = `\u{BC29} \u{CF54}\u{B4DC}: ${roomId}
\u{AC19}\u{C774} \u{BD10}\u{C694}!
${link}`;
        if (navigator.share) try {
            await navigator.share({
                title,
                text,
                url: link
            });
            return;
        } catch  {}
        copyRoomLink();
    }
    // ─── Toast ───
    function toast(msg) {
        const el = document.createElement('div');
        el.className = 'toast';
        el.textContent = msg;
        document.body.appendChild(el);
        setTimeout(()=>el.remove(), 1500);
    }
    // DOM ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();

//# sourceMappingURL=roulette-main.2fa3bf47.js.map
